<template>
	<div class="vopsFormGroup">
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class FormGroup extends Vue {
}
</script>

<style lang="scss">
	.vopsFormGroup {
		padding-left: 16px;
		border-left: solid 1px var(--theme-border-color);
	}
</style>